// extracted by mini-css-extract-plugin
export default {"eventNotStarted":"rkIqb__eventNotStarted","eventDescriptionWrapper":"IDI7K__eventDescriptionWrapper"};